import { Suspense, useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { APICore } from '../helpers/api/apiCore'
import { RolesHelper } from '../helpers/rolesHelper'
const helper = new RolesHelper()

/**
 * Private Route forces the authorization before the route can be accessed
 * @param {*} param0
 * @returns
 */
const RolRoute = ({ component: RouteComponent, module, action, ...rest }) => {
  const loading = () => <div />
  const location = useLocation()
  const api = new APICore()
  const [rol, setRol] = useState(undefined)

  useEffect(() => {
    const getRol = async () => {
      try {
        const parsedRol = await helper.getUserRole()
        setRol(parsedRol)
      } catch (error) {
        setRol(undefined)
      }
    }
    if (!rol) getRol()
  }, [])

  if (api.isUserAuthenticated() === false) {
    return <Navigate to='/account/login' state={{ from: location }} replace />
  }

  if (rol && module && action) {
    if (!(rol.rol === 'Admin' && rol.editable === false)) {
      const moduleFinded = rol.permissions.find(item => item.module === module)
      if (!moduleFinded || moduleFinded[action] !== true) {
        return <Navigate to={{ pathname: '/' }} />
      }
    }
  }

  return (
    <Suspense fallback={loading()}>
      <RouteComponent />
    </Suspense>
  )
}

export default RolRoute
